import React, { PureComponent } from 'react'
import { PropTypes } from 'prop-types';
import clsx from 'clsx';

import {
    withStyles,
    InputBase
} from '@material-ui/core';

import SearchIcon from '@material-ui/icons/Search';

const styles = theme => ({
    search: {
        display: 'flex',
        position: 'relative',
        backgroundColor: "#fff",
        // width: '100%',
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        borderRadius: '4px',
        boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
        flexGrow: 1,
        maxHeight: 40,
        alignItems: 'center',
        margin: 5
    },
    searchIcon: {
        width: theme.spacing(9),
        height: '100%',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
        width: '100%',
    },
    inputInput: {

        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: '90%',
        },
    }
})

class Search extends PureComponent {

    render() {
        const { classes, placeholder, onChange, searchTerm, rightChild, className, loading } = this.props;
        return (
            <div className={clsx(className, classes.search)}>
                <div className={classes.searchIcon}>
                    <SearchIcon />
                </div>
                <InputBase
                    disabled={loading ?? false}
                    placeholder={placeholder}
                    onChange={onChange}
                    autoFocus={false}
                    value={searchTerm}
                    classes={{
                        root: classes.inputRoot,
                        input: classes.inputInput
                    }}
                />
                {rightChild}
            </div>
        );
    }
}

Search.defaultProps = {
    placeholder: "Search...",
}

Search.propTypes = {
    placeholder: PropTypes.string,
    //searchTerm: PropTypes.string.isRequired,
    //onChange: PropTypes.func.isRequired,
    rightChild: PropTypes.element,
}

export default withStyles(styles)(Search);
